import React from 'react';
import '../styles/NotRegistered.css';

function NotRegistered() {
  return (
    <div className="not-registered-container">
      <div className="not-registered-content">
        <h1 className="not-registered-header">Not Registered</h1>
        <p className="not-registered-message">
          You are not signed up yet, please get in contact with Morrow Collective.
        </p>
      </div>
    </div>
  );
}

export default NotRegistered; 